/*
  COMPONENT: Product Card Runtime

  Owns:
  - Interactive color/colour image previews
  - Variant-aware product-card destinations

  Does not own:
  - Product pricing
  - Variant selection or quick-add eligibility
  - Cart state
*/

(() => {
  function initializeProductCards(root = document) {
    root.querySelectorAll('[data-product-card]').forEach((card) => {
      if (card.dataset.swatchesInitialized === 'true') return;

      const swatches = Array.from(card.querySelectorAll('[data-product-card-swatch]'));
      if (!swatches.length) return;

      card.dataset.swatchesInitialized = 'true';
      const primaryImage = card.querySelector('.product-card__image:not(.product-card__image--secondary)');
      const links = Array.from(card.querySelectorAll('[data-product-card-link]'));
      let transitionTimer = 0;

      const finishImageTransition = (variantId) => {
        window.clearTimeout(transitionTimer);
        transitionTimer = window.setTimeout(() => {
          if (card.dataset.activeCardVariant !== variantId) return;
          primaryImage?.classList.remove('is-swatch-changing');
        }, 80);
      };

      const activateSwatch = (swatch) => {
        const variantId = swatch.dataset.cardVariantId || '';
        const variantUrl = swatch.dataset.cardVariantUrl || '';
        const imageSrc = swatch.dataset.cardImageSrc || '';
        const imageSrcset = swatch.dataset.cardImageSrcset || '';
        const imageAlt = swatch.dataset.cardImageAlt || '';

        swatches.forEach((item) => {
          const selected = item === swatch;
          item.classList.toggle('is-active', selected);
          item.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });

        if (variantUrl) links.forEach((link) => link.setAttribute('href', variantUrl));
        if (!primaryImage || !imageSrc || card.dataset.activeCardVariant === variantId) return;

        card.dataset.activeCardVariant = variantId;
        card.classList.add('product-card--swatch-selected');
        primaryImage.classList.add('is-swatch-changing');
        if (imageAlt) primaryImage.alt = imageAlt;
        if (imageSrcset) primaryImage.srcset = imageSrcset;
        primaryImage.src = imageSrc;

        if (typeof primaryImage.decode === 'function') {
          primaryImage.decode().catch(() => {}).finally(() => finishImageTransition(variantId));
        } else {
          finishImageTransition(variantId);
        }
      };

      const handlers = new Map();
      swatches.forEach((swatch) => {
        const handler = () => activateSwatch(swatch);
        handlers.set(swatch, handler);
        swatch.addEventListener('click', handler);
      });

      window.CurtisTheme?.registerCleanup?.(card, () => {
        handlers.forEach((handler, swatch) => swatch.removeEventListener('click', handler));
        window.clearTimeout(transitionTimer);
        delete card.dataset.swatchesInitialized;
      });
    });
  }

  window.CurtisProductCards = {
    initialize: initializeProductCards,
  };

  if (window.CurtisTheme?.register) {
    window.CurtisTheme.register('product-card-swatches', initializeProductCards);
  } else {
    initializeProductCards();
    document.addEventListener('shopify:section:load', (event) => initializeProductCards(event.target));
  }
})();
